import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CompanyResponse, CompanyRoleResponse, PasswordSATRequest } from 'src/app/models/company.model';
import { PaginationModel, SimplePaginationModel } from 'src/app/models/pagination.model';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { CompanyService } from 'src/app/services/company.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { UserSaved } from 'src/app/models/user.model';

@Component({
  selector: 'app-password-sat',
  templateUrl: './password-sat.component.html',
  styleUrls: ['./password-sat.component.scss']
})
export class PasswordSatComponent implements OnInit {
  failedStart = false;
  passwords: PaginationModel = new PaginationModel(0, 5, 0, 0, [{ id: 123, nit: "123", name: "Empresa", password: 'pass' }], []);
  companies: CompanyRoleResponse[] = [];
  allCompanies: CompanyRoleResponse[] = [];
  companiesPassword: CompanyResponse[] = [];
  totalCompaniesPassword: number = 0;
  pagination: SimplePaginationModel = new SimplePaginationModel(0, 6, 0, 0, 0);
  sizes = [6, 12, 36, 60];
  filterWord = "";
  user: UserSaved = null;
  selected = null;
  newPassword = "";
  inputs = new InputAutocompleteModel("", false, true, "", "fa-asterisk", "", "", null, []);
  timeout = null;
  buttonSave = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  modalCreate = false;
  edit: CompanyResponse = null;
  gettingData: boolean = true;
  deleting: {[key: number]: boolean} = {};

  constructor(
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private companyService: CompanyService
  ) {

  }

  ngOnInit(): void {
    this.user = JSON.parse(this.authService.getCurrentUser());
    this.companies = Object.assign(this.companies, this.user.companyRoles);
    this.allCompanies = this.companies;
    this.getPaginationCompaniesPassword();
  }

  deletePasswordSAT(company: CompanyResponse) {
    // To delete passwordsat
    if (this.deleting[company.id]) {
      return;
    }
    this.deleting[company.id] = true;
    this.companyService.deactivatePasswordSAT(company.id).subscribe({
      next: (response: ResponseObject) => {
        this.getPaginationCompaniesPassword();
        this.deleting[company.id] = false;
        this.toastService.success("Contraseña eliminada!");
      },
      error: (error: HttpErrorResponse) => {
        this.deleting[company.id] = false;
        this.toastService.error("Error al eliminar la contraseña");
      }
    })
  }

  filterCompany() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.pagination.page = 0;
      this.getPaginationCompaniesPassword();
    }, 300);
  }

  getPaginationCompaniesPassword() {
    this.companyService.getPaginationCompaiesPassword(
      this.filterWord,
      this.pagination.page,
      this.pagination.size,
      this.user.id,
      this.user.contadorGT
    ).subscribe({
      next: (response: ResponseObject) => {
        var res = response.data as { total: number, companies: CompanyResponse[] }
        this.totalCompaniesPassword = res.total;
        this.companiesPassword = res.companies;
        this.companiesPassword.forEach((company) => {
          company.passwordRequest = new PasswordSATRequest();
        });
        this.pagination.total = this.totalCompaniesPassword;
        this.pagination.start = this.pagination.page * this.pagination.size + 1;
        this.pagination.end = this.pagination.page * this.pagination.size + res.companies.length;
        this.gettingData = false;
      },
      error: (error: HttpErrorResponse) => {
        this.gettingData = false;
        this.toastService.error("Error al obtener las contraseñas");
      }
    })
  }

  copy(copyText) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = copyText;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastService.success("Contraseña pegada al portapapeles!");
  }
}
